
import { Component, Prop, Vue } from 'vue-property-decorator'
import FormContainer from "@/components/processing_steps/commons/forms/FormContainer.vue"
import NewCurrencyField from "@/components/processing_steps/commons/fields/NewCurrencyField.vue"
import { IPSFinanceForm, IPSFinanceFormErrors } from '@/types/processingSteps'

@Component({
  components: {
    NewCurrencyField,
    FormContainer
  }
})
export default class ProjectFinancingNeedsForm extends Vue {
  @Prop() financeForm!: IPSFinanceForm
  @Prop() financeFormErrors!: IPSFinanceFormErrors
  @Prop({ default: false }) isDisabled!: boolean

  onGoalInCentsChange(newValue: string) {
    this.$emit('update:financeForm', { ...this.financeForm, goal_in_cents: newValue })
  }
}
